import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { Injectable } from '@angular/core';

@Injectable()
export class NgbDateCustomParserFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    const parts = value.trim().split('/');

    if (parts.length === 3) {
      return {
        day: parseInt(parts[0], 10),
        month: parseInt(parts[1], 10),
        year: parseInt(parts[2], 10),
      };
    }

    return null;
  }

  format(date: NgbDateStruct): string {
    return date ? `${this.padNumber(date.day)}/${this.padNumber(date.month)}/${date.year}` : '';
  }

  private padNumber(value: number | undefined): string {
    if (!value) {
      return '';
    }
    return value < 10 ? `0${value}` : `${value}`;
  }
}
